// tktuner whoami — account + device + sync state.
import pc from "picocolors";
import { ApiError, apiCall } from "../lib/api-client";
import { readCredentials } from "../lib/credentials";
import { openDb } from "../store/db";
import { Store } from "../store/queries";

export async function whoami(opts: { db?: string }): Promise<void> {
  const creds = readCredentials();
  if (!creds) {
    console.log(`Not logged in. Run ${pc.bold("tktuner login")}.`);
    return;
  }
  try {
    const status = await apiCall("GET", creds.apiUrl, "/v1/sync/status", {
      token: creds.deviceToken,
    });
    console.log(`${pc.bold(String(status.email))} · device ${creds.deviceName} → ${creds.apiUrl}`);
    console.log(
      `server: ${pc.bold(String(status.serverTurnCount))} turns · last sync ${
        status.lastSyncedAt ? String(status.lastSyncedAt) : "never"
      }`,
    );
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) {
      console.error(pc.red(`Device token was revoked. Run ${pc.bold("tktuner login")} again.`));
      process.exitCode = 1;
      return;
    }
    throw err;
  }
  const db = openDb(opts.db);
  try {
    const store = new Store(db);
    const wm = store.getMeta("sync_last_turn_rowid") ?? "0";
    console.log(`local: ${store.countTurns()} turns · sync watermark @ row ${wm}`);
  } finally {
    db.close();
  }
}
